// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { categoryListPageStyles } from "@ces/Overrides/Pages/CategoryListPage";
import { DivWrapper } from "@ces/XDL/constants";
import { xScreen } from "@ces/XDL/Utilities";
import { css } from "styled-components";

categoryListPageStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 317px auto;
        gap: 22px;
        ${xScreen("lte", "md")} {
            display: flex;
            gap: 0;
        }
    `,
};

categoryListPageStyles.leftSide = {
    css: css`
        ${DivWrapper}:empty {
            display: none;
        }
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

categoryListPageStyles.rightSide = {
    css: css`
        h1[data-test-selector="PageTitle"] {
            margin-bottom: 20px;
        }
        ${xScreen("lte", "md")} {
            h1[data-test-selector="PageTitle"] {
                margin-bottom: 12px;
            }
        }
    `,
};
